import { render, staticRenderFns } from "./FormResource.vue?vue&type=template&id=7a9e8695&scoped=true"
import script from "./FormResource.vue?vue&type=script&lang=js"
export * from "./FormResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9e8695",
  null
  
)

export default component.exports